import styled from 'styled-components'
import Flex from 'components/Flex'

export const Container = styled(Flex)`
  height: 90vh;
  width: 100vw;
  background-color: #fafafb;
  gap: 40px;
`
export const Content = styled(Flex)`
  height: auto;
  background-color: white;
  border: 1px solid #e6e7ea;
  box-shadow: 0px 6px 10px rgba(86, 94, 106, 0.1);
  padding: 50px 75px 75px 75px;
  gap: 20px;
  border-radius: 10px;
  width: 48%;
`
export const Heading = styled(Flex)`
  font-weight: 700;
  font-size: 1.4285714285714286em;
  line-height: 28px;
  color: #010e30;
  padding-bottom: 15px;
`
export const TableHeading = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #4d566e;
`
export const Table = styled(Flex)`
  padding: 15px;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 15px;
`
export const TableText = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #1b1f22;
  padding-top: 2px;
`
export const TableText1 = styled.a`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: blue;
  padding-top: 2px;
`


export const TableSubText = styled(Flex)`
  padding-top: 5px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #a4a5a7;
`
export const VerifiedText = styled(Flex)`
  ont-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #5db594;
`
export const Wrapper = styled(Flex)`
  padding-right: 15px;
`
